import HttpClient from '@microbadevs/http-client'
import authService from '@/services/authService'

export default class HttpClientService {
  static getReportAPIHttpClient () {
    return new HttpClient(process.env.API_ROOT_REPORT, process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken())
  }
  static getAPIHttpClient () {
    return new HttpClient(process.env.API_ROOT, process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken())
  }
  static getPdfHttpClient () {
    return new HttpClient(process.env.API_ROOT_REPORT, process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken(), true)
  }
}



// WEBPACK FOOTER //
// ./src/services/httpClientService.js